// extracted by mini-css-extract-plugin
export default {"header":"Header_header__3oa6c","headerSection":"Header_headerSection__Ghk1u"};